/* global ProfilePageIntroductionConditionsInformer, ProfilePageIntroductionElementProvider, SlideInElementFrameInitiator */

window.ProfilePageIntroductionInitiator = {
	initiator: null,
	element: null,

	init() {
		if (!this.neededElementsAvailable()) {
			return;
		}

		this.initiateProfilePageIntroduction();
	},

	neededElementsAvailable() {
		if (
			!window.ProfilePageIntroductionElementProvider ||
			!window.ProfilePageIntroductionConditionsInformer ||
			!window.SlideInElementFrameInitiator
		) {
			console.warn(
				'ProfilePageIntroductionInitiator.neededElementsAvailable: One or more necessary objects not available on window'
			);
			return false;
		}

		this.initiator = new SlideInElementFrameInitiator();
		this.element = ProfilePageIntroductionElementProvider.getElement();
		if (!this.element) {
			console.warn('ProfilePageIntroductionInitiator.constructor: ProfilePageIntroduction element not found.');
			return false;
		}

		return true;
	},

	initiateProfilePageIntroduction() {
		const welcomeMessage = this.element.querySelector('.SlideInElementContentWrapper');
		if (!welcomeMessage) {
			return;
		}

		welcomeMessage.addEventListener('click', () => {
			const redirectUrl = this.buildUrl();
			window.location = redirectUrl;
		});

		ProfilePageIntroductionConditionsInformer.triggerAfterYoloRegistration(() => {
			this.initiator.trigger(this.element);
			Loot.DataStorage.store('ProfilePageIntroductionShown', true, 60 * 60 * 24 * 30);
		});
	},

	buildUrl() {
		const currentUrl = new URL(window.location);
		const baseUrl = currentUrl.origin;

		return baseUrl + '/account/?section=recommendations';
	}
};

document.addEventListener('DOMContentLoaded', () => {
	ProfilePageIntroductionInitiator.init();
});
